import { BackgroundSection } from '@/layouts/DefaultLayout/components/BackgroundSection/BackgroundSection'
import { Content } from '@/layouts/DefaultLayout/components/Content/Content'

import { PasswordResetVerifyForm } from '@/modules/passwordReset/components/PasswordResetVerifyForm/PasswordResetVerifyForm'

import { Title } from '@/components/Title/Title'

export function Component() {
  return (
    <>
      <BackgroundSection image="../welcome_image_step_2.png" />
      <Content>
        <>
          <Title variant="h1">Create New Password</Title>

          <PasswordResetVerifyForm />
        </>
      </Content>
    </>
  )
}

Component.displayName = 'PasswordResetVerify'
